import { render, staticRenderFns } from "./MiniBasket.vue?vue&type=template&id=850db8ec"
import script from "./MiniBasket.vue?vue&type=script&lang=js"
export * from "./MiniBasket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports